import { arrayOf, func, object } from 'prop-types';
import { mergeDeepRight, path } from 'ramda';
import React from 'react';
import { Row, Col, Grid } from 'react-flexbox-grid';
import { connect } from 'react-redux';

import { colors } from 'styles/provider';
import ActionButton from 'components/ActionButton';
import Rehab1 from './Rehab1';
import Rehab2 from './Rehab2';
import Rehab3 from './Rehab3';
import Rehab4 from './Rehab4';
import Rehab5 from './Rehab5';
import Rehab6 from './Rehab6';
import Rehab7 from './Rehab7';
import Rehab8 from './Rehab8';

import { ViewStyles } from './View.less';
import { actions } from 'store/newDocumentStore';
import { getAllCommitsData, getLatestFinishedCommitData } from 'lib/documentHandling';

const Divider = () => (
  <div style={{ width: '100%', height: '2rem', marginTop: '2rem', borderTop: `0.2rem solid ${colors.clrSecondary}` }} />
);

const Rehabilitations = ({ fm, document, allDocuments, closeView, commitPut }) => {
  const data = getAllCommitsData(document);
  const dataFinished = getAllCommitsData(document, true);

  const rehab1Data = path(['rehab1'], data);
  const rehab2Data = path(['rehab2'], data);
  const rehab3Data = path(['rehab3'], data);
  const rehab4Data = path(['rehab4'], data);
  const rehab5Data = path(['rehab5'], data);
  const rehab6Data = path(['rehab6'], data);
  const rehab7Data = path(['rehab7'], data);
  const rehab8Data = path(['rehab8'], data);

  const fatigueDiaryDocument = allDocuments
    .filter(d => d.documentType === 'fatigueTrackingDiary')
    .sort((a, b) => b.createDate - a.createDate)[0];
  const fatigueData = fatigueDiaryDocument && getLatestFinishedCommitData(fatigueDiaryDocument);

  const commitPutRehab = newRehabData => {
    const putData = mergeDeepRight(data, { ...newRehabData });
    commitPut('onlineRehabilitation', document.documentId, putData);
  };

  return (
    <div className={ViewStyles}>
      <Grid fluid>
        <Row end="xs">
          <Col style={{ paddingRight: '0.5rem' }}>
            <ActionButton localeId="npView.history.close" onClick={closeView} secondary border />
          </Col>
        </Row>
        <Divider />
        {rehab1Data && (
          <div>
            <Rehab1 data={rehab1Data} fm={fm} documents={allDocuments} />
            <Divider />
          </div>
        )}
        {rehab2Data && (
          <div>
            <Rehab2 data={rehab2Data} fm={fm} fatigueData={fatigueData} />
            <Divider />
          </div>
        )}
        {rehab3Data && (
          <div>
            <Rehab3
              data={rehab3Data}
              dataFinished={path(['rehab3'], dataFinished)}
              fatigueData={fatigueData}
              fm={fm}
              documentId={document.documentId}
              commitPutRehab={commitPutRehab}
            />
            <Divider />
          </div>
        )}
        {rehab4Data && (
          <div>
            <Rehab4
              data={rehab4Data}
              dataFinished={path(['rehab4'], dataFinished)}
              fm={fm}
              documentId={document.documentId}
              commitPutRehab={commitPutRehab}
            />
            <Divider />
          </div>
        )}
        {rehab5Data && (
          <div>
            <Rehab5
              data={rehab5Data}
              dataFinished={path(['rehab5'], dataFinished)}
              fm={fm}
              documentId={document.documentId}
              commitPutRehab={commitPutRehab}
            />
            <Divider />
          </div>
        )}
        {rehab6Data && (
          <div>
            <Rehab6
              data={rehab6Data}
              dataFinished={path(['rehab6'], dataFinished)}
              fm={fm}
              documentId={document.documentId}
              commitPutRehab={commitPutRehab}
            />
            <Divider />
          </div>
        )}
        {rehab7Data && <Rehab7 data={rehab7Data} fm={fm} />}
        {rehab8Data && <Rehab8 data={rehab8Data} fm={fm} documents={allDocuments} />}
      </Grid>
    </div>
  );
};

Rehabilitations.propTypes = {
  fm: func,
  document: object,
  allDocuments: arrayOf(object),
  closeView: func,
  commitPut: func,
};
export default connect(null, { commitPut: actions.commitPut })(Rehabilitations);
